// @flow

import type { ContextRouter } from 'react-router'
import type { EasyCompMap, Visitor } from 'projects/easy/public/type'

import React from 'react'
import EasyCms from 'projects/easy/public'
import { connect } from 'react-redux'
import requireVisitor from '../hoc/requireVisitor'
import clientHeight from 'frame/hoc/clientHeight'

type Props = ContextRouter & {
  visitor: Visitor,
  clientHeight: number
};

type State = {
  rootData?: EasyCompMap
};

function mapStateToProps (state) {
  return {
    visitor: state.vars.visitor
  }
}

@clientHeight
@requireVisitor
@connect(mapStateToProps)
export default class extends React.PureComponent<Props, State> {
  state = {};

  render () {
    const { clientHeight: height, visitor, match } = this.props
    return (
      <div id='easy-comp-container' style={{ height, position: 'relative' }}>
        <EasyCms code={match.params.code} visitor={visitor} height={height} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/fengjr/cms/CMS.js